// extracted by mini-css-extract-plugin
module.exports = {"block":"jO2RD","policy":"_27dRm","link":"Wlxm8"};